// To prevent the active / focus style being applied unless it's keydown and not click
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const preventDefault = (e: React.MouseEvent<any>): void =>
    e.preventDefault();
